import React from 'react';
import debounce from 'lodash/debounce';
import { replaceWithJioCDN } from '../../utils/imageHandling';

function elementInViewport(el, offsetTop = 0) {
  if (!el) return false;
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.top - offsetTop <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

export default class LazyImage extends React.Component {
  constructor(props) {
    super(props);
    this.img = null;
    this.state = {
      isInViewport: false,
      show: false
    };
  }

  onScrollWindow = () => {
    if (this.img) {
      const { offsetTop = 0 } = this.props;
      const { show } = this.state;
      const isInViewport = elementInViewport(this.img, offsetTop);
      this.setState({
        isInViewport,
        show: show || isInViewport
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    const { offsetTop = 0 } = nextProps;
    if (this.img) {
      const { show } = this.state;
      const isInViewport = elementInViewport(this.img, offsetTop);
      this.setState({
        isInViewport,
        show: show || isInViewport
      });
    }
  }

  render() {
    const { isInViewport = false, show = false, isLoaded = false } = this.state;
    let { src, offsetTop, wait, className, alt, ...rest } = this.props;
    className = `rilrtl-lazy-img ${className || ''} ${isLoaded ? 'rilrtl-lazy-img-loaded' : ''}`;
    return (
      <img
        ref={img => {
          this.img = img;
        }}
        alt={alt ?? 'Product Image'}
        {...rest}
        src={show ? replaceWithJioCDN(src) : null}
        className={className}
        onLoad={() => {
          this.setState({ isLoaded: true });
          if (this.props.onLoad) {
            this.props.onLoad();
          }
        }}
      />
    );
  }

  componentDidMount() {
    const { offsetTop = 0, wait = 0 } = this.props;
    this._debouncedScroll = debounce(this.onScrollWindow, wait);
    window.addEventListener('scroll', this._debouncedScroll, { passive: true });
    const isInViewport = elementInViewport(this.img, offsetTop);
    if (isInViewport) {
      this.setState({ isInViewport: true, show: true });
    } else if (wait > 0) {
      this.timeoutID = setTimeout(() => {
        const inView = elementInViewport(this.img, offsetTop);
        this.setState({ isInViewport: inView, show: inView });
      }, wait);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._debouncedScroll);
    this.img = null;
    if (this.timeoutID) {
      window.clearTimeout(this.timeoutID);
    }
  }
}
